import styled from "styled-components";

export const MainContainer = styled.div`
  text-align: center;
  width: 100%;
  max-width: 450px;  
  padding: 20px;
  box-sizing: border-box; 

  .para {
    font-size: 18px;
    text-align: center;
  }
  .formContainer {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .inputBox {
    width: 100%;
    font-size: 18px;
    padding: 10px 16px;
    margin-bottom: 16px;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.15);
    outline: none;
    border: none;
    color: #ffffff;
    box-sizing: border-box; 
  }
  .btn {
    width: 100%;   
    box-sizing: border-box; 
  }

  .logo-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  .logo {
    width: 200px;
    height: auto;
  }

  .resend-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
    font-size: 14px;
  }

  .resend-active {
    color: var(--brand, #B87333);
    cursor: pointer;
    font-weight: 600;
    text-decoration: underline;
  }

  .resend-timer {
    color: rgba(255, 255, 255, 0.5);
  }

  .resend-timer span {
    color: var(--brand, #B87333);
    font-weight: 600;
  }
`;

export const PasswordContainer = styled.div`
  position: relative;
  width: 100%;

  /* Reserve room for the eye icon so long passwords don't run underneath it.
     Doubled selector outranks the !important padding in ott-premium-mobile.css. */
  && .inputBox {
    padding-right: 48px !important;
    text-overflow: ellipsis;
  }

  .eyeIcon {
    position: absolute;
    right: 16px;
    top: 37%;
    transform: translateY(-50%);
    cursor: pointer;
    color: rgba(255, 255, 255, 0.7);
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;
    
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const Line = styled.div`
  margin-top: 10px;
  display: flex;
  .line {
    width: 48%;
  }
  .text {
    margin: 0px 10px;
  }
`;

export const ParaContainer = styled.div`
  margin: 5px 0px;
`;

export const LoginContainer = styled.div`
  color: #ffffff;
  background: #000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`;